import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import Label from '../Label/Label';
import Link from '../Link';
import GenericList from './GenericList';
import GenericListItem from './GenericListItem';

const GenericListDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Generic List</h4>
        <Row>
          <Col className="mt-10 p-0">
            <GenericList>
              <GenericListItem>
                <Link
                  rightIcon={light('arrow-up-right-from-square')}
                  onSelect={(selectedKey) =>
                    console.log(`selected ${selectedKey}`)
                  }
                  eventKey="test"
                >
                  General links to external site
                </Link>
              </GenericListItem>
              <GenericListItem withoutBorder>
                <Link rightIcon={light('arrow-up-right-from-square')} isBlue>
                  General links to external site
                </Link>
              </GenericListItem>
              <GenericListItem>
                <Link
                  rightIcon={light('arrow-up-right-from-square')}
                  isAlignAtEnd
                >
                  General links to external site
                </Link>
              </GenericListItem>
              <GenericListItem>
                <Link
                  rightIcon={light('arrow-up-right-from-square')}
                  isAlignAtEnd
                  isBlue
                >
                  General links to external site
                </Link>
              </GenericListItem>
              <GenericListItem price={900000} hasDot>
                List item goes here
              </GenericListItem>
              <GenericListItem price={900000}>
                List item goes here
              </GenericListItem>
              <GenericListItem>
                <Label leftIcon={light('circle-exclamation')}>
                  Label with left icon
                </Label>
              </GenericListItem>
              <GenericListItem>
                <Label rightIcon={light('circle-exclamation')}>
                  Label with right icon
                </Label>
              </GenericListItem>
              <GenericListItem>
                <Label
                  rightIcon={light('circle-question')}
                  leftIcon={light('circle-exclamation')}
                >
                  Label with left and right icon
                </Label>
              </GenericListItem>
              <GenericListItem>
                <Label statusDot="orange">Label with status dot</Label>
              </GenericListItem>
            </GenericList>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Container>
  );
};

export default GenericListDemo;
